// extracted by mini-css-extract-plugin
module.exports = {"CardLabel_container":"CardLabel_CardLabel_container__35mh0","CardLabel_title":"CardLabel_CardLabel_title__13dWe"};